import { OUTPUT_LANGUAGES, OUTPUT_LANGUAGE_NAMES } from "@signalist/shared-types";

import { SelectFieldOptions } from "@/components/SelectField/SelectField";

/**
 * Dropdown options for every "AI output language" setting (deep research,
 * signals, lead scoring). Sourced from the shared EU language list so the web
 * dropdowns and the API validation always agree (PREC-3485).
 */
export const outputLanguageOptions: SelectFieldOptions = OUTPUT_LANGUAGES.map((code) => ({
	title: OUTPUT_LANGUAGE_NAMES[code],
	value: code,
}));
